import { twMerge } from 'tailwind-merge';
import { PropsWithChildren } from 'react';

import { Nullable } from 'types';
import { TopNavigation } from 'components';

import { Background } from '../background';

interface PrivateLayoutProps extends PropsWithChildren {
  logoUrl?: Nullable<string>;
  backgroundClassName?: string;
}

export const PrivateLayout = ({
  logoUrl,
  children,
  backgroundClassName,
}: PrivateLayoutProps) => (
  <div className="flex min-h-screen w-screen">
    <Background className={twMerge('z-[1]', backgroundClassName)} />
    <div className="relative z-10 flex w-full flex-col">
      <div className="sticky top-0 right-0 left-0 z-20 mx-auto w-full max-w-360 md:top-4">
        <div className="bg-white-primary md:shadow-primary relative shadow-[0_8px_16px_rgba(0,0,0,0.04)] md:mx-6 md:rounded-3xl">
          <Wrapper>
            <TopNavigation logoUrl={logoUrl} />
          </Wrapper>
        </div>
      </div>
      <Wrapper className="flex min-h-0 flex-1 flex-col py-6 md:mt-4">
        {children}
      </Wrapper>
    </div>
  </div>
);

const Wrapper = ({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) => (
  <div
    className={twMerge(
      'w-full px-6 lg:mx-auto lg:max-w-(--max-content-width)',
      className
    )}
  >
    {children}
  </div>
);
